var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c("Header", {
        attrs: { tab: _vm.tab },
        on: {
          tabChange: function ($event) {
            _vm.tab = $event
          },
          currentGroup: _vm.currentGroupFunc,
        },
      }),
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: { id: "main_content_maxwidthset", cols: "12" },
        },
        [_vm.tab === 0 ? [_c("CameraListTab")] : [_c("SplitScreenTab")]],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }